import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/mould'

/** 模具下拉选接口 */
export const getMouldOptions = () => {
  return axios.get(`${rootApi}/getOptions`)
}
